import { useState, useEffect, useCallback } from 'react'
import { useMutation } from "@tanstack/react-query"

import { showLoading } from 'services/util'

// TODO - Copy this over or move it to a shared area. We never want one app getting stuff from another app.
// import checkmark from '../components/images/check-circle.svg'

import { graphql } from '../api'
import { createAuctionMutation } from '../graphql/Mutations'

import css from './sass/createedit.module.scss'
import themeCss from '../components/sass/theme.module.scss'
import { handleEscapeKey } from '../components/utils'

const emptyFn = () => {}

export default function CreateAuction(props) {

  const refreshPreviewAuctionQuery = props.refreshPreviewAuctionQuery
  const auctionCodes = props.auctionCodes
  const setHideCloseModalButton = props.setHideCloseModalButton || emptyFn
  const showCreateAuctionModal = props.showCreateAuctionModal || emptyFn
  // item Id to be auto-generated in resolver using util.autoId()
  const [auctionCode, setAuctionCode] = useState('')
  const [title, setTitle] = useState('')
  
  const [createdAuction, setCreatedAuction] = useState()

  //validators
  const [invalidCode, setInvalidCode] = useState('')
  
  const [canSubmit, setCanSubmit] = useState(false)

  const [createSuccess, setCreateSuccess] = useState(false)
  
  const {data: createAuctionResponse, error, isPending, mutate: saveAuction } = useMutation({
    mutationFn: (input) => {
      return graphql({query: createAuctionMutation, variables: {input: input} })
    },
  })

  const toggleModal = useCallback(() => {
    showCreateAuctionModal(false)
  }, [showCreateAuctionModal])

  useEffect(() => {
    const onKeyDown = (event) => handleEscapeKey(event, toggleModal)
    //add event listener for when modal is mounted
    document.addEventListener('keydown', onKeyDown)
    //clean up when modal is unmounted
    return () => document.removeEventListener('keydown', onKeyDown)

  }, [toggleModal])

  useEffect(() => {
    showLoading(isPending, "CreateAuction")
  }, [isPending])

  useEffect(() => {
    if (error) {
      console.log("Auction not created: ", error)
      console.log(error.errors[0].message) // errors from Appsync take this format, there may be other formats depending on where the operation fails
    }
    else if (createAuctionResponse) {
      console.log(createAuctionResponse)
      console.log('Auction created: ', createAuctionResponse.data.createAuction.AuctionId)

      const newAuction = {Title: title.trim(),
        AuctionCode: auctionCode.trim(),
        AuctionId: createAuctionResponse.data.createAuction.AuctionId,
      }
      setCreatedAuction(newAuction)
      refreshPreviewAuctionQuery()
      setCreateSuccess(true)
    }
  }, [createAuctionResponse, error, refreshPreviewAuctionQuery, title, auctionCode])

  useEffect(() => {

    setInvalidCode('')
    if (auctionCodes.indexOf(auctionCode) > -1) setInvalidCode('Please enter another Auction Code, this code is in use on an active auction.')

  }, [auctionCode, auctionCodes])

  useEffect(() => { 
    //checking to see if all required fields have a value
    const requiredFieldsNonBlank = [auctionCode, title].every(field => field.trim() !== '')
    setCanSubmit(!invalidCode && requiredFieldsNonBlank)
  }, [invalidCode, auctionCode, title])

  const onSubmit = async (e) => {
    e.preventDefault()

    const input = {
      Title: title.trim(),
      AuctionCode: auctionCode.trim(),
      IsForTestOnly: !!localStorage.isSeleniumTest,
      //set default value of needs check in, it's defaulting to true on creation
      NeedsCheckin: false
    }

    setCreatedAuction(input)
    saveAuction(input)
  }

  if (createSuccess) {

    //if the auction was created successfully, reroute to the manage auction page
    props.history.push({
                  pathname: '/admin/auctiondetail',
                  search: `?auctionId=${createdAuction.AuctionCode}`,
                })
  }
  if (error) {
    return (
      <p>There was an error creating the auction, please try again.</p>
    )
  }

  return (
    <div className={css['page-container']}>
      <form onSubmit={onSubmit}>
        <h2>Add Auction</h2>
        
        <div className={css['item-container']}>

          <div className={css['create-item-input']}>
            <label>Title</label>
            <input id="createAuctionTitle" type='text'
              placeholder='e.g. UCLA Auction'
              value={title}
              onChange={(e) => setTitle(e.target.value)}/>  
          </div>
        
          <div className={css['create-item-input']}>
            <label>Auction Code</label>
              <p className={css['label-notice']}>(must be unique, suggested to use the current year, cannot be edited after initialization)</p>
              <p className={css['label-notice']}>(this will appear after auctions.support2.ucla.edu/)</p>
            <input id="createAuctionCode" type='text'
              value={auctionCode}
              placeholder="e.g. pier-2024"
              onChange={(e) => setAuctionCode(e.target.value)}/>
            {invalidCode && <p className={themeCss['error-text']}>{invalidCode}</p>}
          </div>
          
        </div>
        {!canSubmit && 
        <div className={css['required-messages']}>
          {title === '' && <p>Auction Title is missing.</p>}
          {auctionCode === '' ? <p>Auction Code is missing.</p> : invalidCode ? <p>Auction Code is already in use.</p> : ''}
        </div>}
        <button id="createAuctionSubmit" className={`${themeCss['button']} ${themeCss['FilledBlue']} ${themeCss['centered-button']}`}
          disabled={!canSubmit}
          type='submit'>Create Auction</button>
      </form>
    </div>
  )
}